import { BllKategoriler } from './../../../providers/bll/bll-kategoriler';
import { BllStoklar } from './../../../providers/bll/bll-stoklar';
import { BllViewStoklar } from './../../../providers/bll/bll-ViewStoklar';
import { DalProvider } from './../../../providers/dal/dal';
import { SyncProvider } from './../../../providers/syncProvider';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { BarcodeScannerProvider } from '../../../providers/barcode-scanner-provider';


@Component({
  selector: 'page-stokekle',
  templateUrl: 'stokekle.html',
})
export class StokeklePage {
  gununtarihi: any;
  Stok: any = {
    ID: -1, PLU: 0, Price1: 0, Price2: 0, Entegrasyon: 1, Guncellendi: 1, Price3: 0, IsTerazi: 0,
    Price4: 0, Vat: 8, VatGrupId: 1, BirimId: 1, Status: 0, MarkId: 1, KategoriID: 1, UlkeID: 1, MinumumSeviye: 100,
    MaximumSeviye: 999, BagliStokID: "", ParentAktif: 0 ,  DovizTipi:1,  DolarKur:0,
  };
  Par: any = {
DolarKur:"0"
  };
  vwUrun: any = {};
  BirimListesi = [];
  DovizListesi = [];
  KategoriListesi = [];
  MarkaListesi = [];
  KdvGrupListesi = [];
  lclekle = [];
  lclViewEkle = [];
  DovizTipi:number=1;
  DovizFiyat:number=0;
  aranan = "";
  StokMiktari:number=0;
  skip: number = 0;
  take: number = 50;
  UlkeListesi = [];
  YerliMi = false;
  barkodkontrolu: number;
  vwPStokEkle: any;
  hideMe=false;
DolarKuru:any=0;

  constructor(private barcodeScanner: BarcodeScannerProvider,
    public navCtrl: NavController,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public bllOrtak: BllOrtak,
    public syncProvider: SyncProvider,
    public dalProvider: DalProvider,
    public navParams: NavParams) {
    if (navParams.get("vwUrun") != null) {
      this.vwUrun = navParams.get("vwUrun");
      var data = new FormData();
      data.append("Stok_id", this.vwUrun.ID);
      this.bllOrtak.islem(data, "StokGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.Stok = Sonuc.SonucObject;
  this.hideMe=false;
     

      }


      )

    }
    else{
      this.hideMe=true;
    }
    if (navParams.get('barkod') != null) {
      this.Stok.Barcode1 = navParams.get('barkod');
    }
    if (navParams.get('vwPStokEkle') != null) {
      this.Stok.Barcode1 = navParams.get('vwPStokEkle');
    }
    if (navParams.get('varyant') != null) {
 
    }
    this.GunlukDolarKur();
  }

  fiyatdegistir(e) {
    if (e.keyCode == 13) {
      
     this.Stok.Price1=this.DolarKuru*this.Stok.DolarFiyat;
    }
   
  }
GunlukDolarKur()
{  var data = new FormData();
  this.bllOrtak.islem(data, "ParametreleriVer", "", false).then(a => {
    var Sonuc = <any>a;
    this.Par = Sonuc.SonucObject;
      this.DolarKuru=this.Par.DolarKur;});
}
  ionViewDidLoad() {
    this.BirimGetir();
    this.MarkaGetir();
    this.KategoriGetir();
    this.Tarihgetir();
    this.KdvGetir();
    this.UlkeGetir();
  this.DovizTipGetir() 

  }
  kapat() {

    this.viewCtrl.dismiss();


  }
  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;

      this.Stok.Barcode1 = sonuc.text;


    })
  }
  barkodkontrol() {
    var formData = new FormData();
    formData.append("Barkod_id", this.Stok.Barcode1);
    this.bllOrtak.islem(formData, "BarkodKontrol", "", false).then(a => {
      var sonuc = <any>a;
      this.barkodkontrolu = sonuc.SonucObject;
    })
  }
  ctrl() {
    var formData = new FormData();
    formData.append("Barkod_id", this.Stok.Barcode1);
    this.bllOrtak.islem(formData, "BarkodKontrol", "", false).then(a => {
      var sonuc = <any>a;
      this.barkodkontrolu = sonuc.SonucObject;
    })
    if (this.barkodkontrolu != this.Stok.Barcode1) {
      this.kaydet();
    }
    else if (this.barkodkontrolu == this.Stok.Barcode1) {
      this.ortak.showBasicAlert("Hata", "Bu Barkod Zaten Kayıtlı");
    }

  }

  boslukKontrol() {
    var mesaj = "";
    if (this.Stok.StokAdi == null || this.Stok.StokAdi == "") {
      mesaj = mesaj + "Lütfen Stok adını giriniz. <br/>";
    }

    if (this.Stok.VatGrupId == null || this.Stok.VatGrupId == "") {
      mesaj = mesaj + "Lütfen Kdv grubu seçiniz. <br/>";
    }
    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }

  }

  yerlikontrol() {
    if (this.Stok.UlkeID == 1) {
      this.Stok.YerliMi = 1;
    }
    else
      this.Stok.YerliMi = 0;
  }
  kaydet() {

    this.yerlikontrol();
    var formData = new FormData();
    if (this.boslukKontrol()) {
      formData.append("Stok_json", JSON.stringify(this.Stok, this.Stok.FiyatDegisimTarihi = this.gununtarihi));
      formData.append("GirilenStok", this.StokMiktari.toString());
      formData.append("DovizTipi", this.DovizTipi.toString());
      formData.append("DovizFiyat", this.DovizFiyat.toString());
      this.bllOrtak.islem(formData, "StokEkleGuncelle", "", false).then(a => {
       // var sonuc = <any>a; 
       this.kapat();
      
       // if (sonuc.Sonuc == 1) {
          // if (this.Stok.ID == -1) {
          //   console.log("11",sonuc)
          //   // stok = sonuc.SonucObject;
          //   //this.lclekle = sonuc.SonucObject;
          //   //this.lcladditem(this.lclekle[0]);
          //   this.ortak.showBasicAlert("Uyarı", "İşlem Başarılı");
          //   this.kapat();
          // }
          // if (this.Stok.ID != -1) {
          //   console.log("22",sonuc)
          // //  var stoklarview = new BllViewStoklar();
          //  // // var stokkarti = new BllStoklar();
          //  // stoklarview.Duzenle(this.Stok);
          //  // // stokkarti.FiyatlariGuncelle(this.Stok);
          //  this.ortak.showBasicAlert("Uyarı", "İşlem Başarılı");
          //   this.kapat();
          // }
      //     this.ortak.showBasicAlert("Uyarı", "İşlem Başarılı");
      //     this.kapat();
      //   }
      //   if (sonuc.Sonuc != 1) {
      //     this.ortak.showBasicAlert("Hata", "Beklenmedik Bir Hata Oluştu");
      //   }
        });
    }
  }
  lcladditem(stok) {
   
    var bllstokkart = new BllStoklar();
console.log("eklenecekStok",stok)
    bllstokkart.StokKartiEkle(stok.ID, stok.Kodu, stok.StokAdi, stok.Barcode1, stok.Barcode2, stok.Vat,
      stok.KategoriID, stok.MarkId, stok.VatGrupId, stok.Price1, stok.Price2, stok.Price3, stok.Price4,
      stok.BirimId, stok.IsTerazi,
      stok.PLU, stok.MaximumSeviye, stok.MinumumSeviye, stok.YerliMi, stok.UlkeID, stok.Status, stok.WebStatus,stok.ParentAktif
      ,stok.DolarFiyat,stok.DovizTipi,stok.DovizSimge).then(a => {
        this.stokekleview();
      });
  }
  stokekleview() {
    this.bllOrtak.islemWithoutPost("StokEkleView", "", false).then(a => {
      var sonuc = <any>a;
      this.lclViewEkle = sonuc.SonucObject;
      this.lclviewekle(this.lclViewEkle[0]);

    });
  }
  lclviewekle(stok) {
    var bllstokkartiview = new BllViewStoklar();
    bllstokkartiview.StokKartiEkle(stok).then(a => {
      this.viewCtrl.dismiss(this.Stok.Barcode1);


    });

  }

  Tarihgetir() {
    this.gununtarihi = new Date().toISOString();
  }
  BirimGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "BirimListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.BirimListesi = sonuc.SonucObject;

    })
  }


  KategoriGetir() {
    // var kategoriler = new BllKategoriler();
    // kategoriler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(KategoriAdi,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + "" + "%' or KategoriAdi='" + "" + "')" + " order by Sort").then(a => {
    //   var sonuc = <any>a;
    //   this.KategoriListesi = sonuc;
    //   if (this.KategoriListesi == null || this.KategoriListesi.length == 0) {
          var formData = new FormData();
        formData.append("aranan", "");
        this.bllOrtak.islem(formData, "KategoriListesi", "", false).then(a => {
          var sonuc = <any>a;
          this.KategoriListesi = sonuc.SonucObject;
        })
     // }
   // });
  }
  UlkeGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "Ulkeler", "", false).then(a => {
      var sonuc = <any>a;
      this.UlkeListesi = sonuc.SonucObject;
    })

  }
  MarkaGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "MarkaListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.MarkaListesi = sonuc.SonucObject;

    })
  }

  DovizTipGetir() {
    var formData = new FormData();
 
    this.bllOrtak.islem(formData, "DovizTipleri", "", false).then(a => {
      var sonuc = <any>a;
      this.DovizListesi = sonuc.SonucObject;

    })
  }
  KdvGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KdvListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KdvGrupListesi = sonuc.SonucObject;
    })
  }

}


// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stokekle/stokekle.ts